export default __webpack_public_path__ + "static/media/water.9712a7a8.png";